<template>
    <div>
        <vs-alert v-if="this.project" :active="this.project.denied" class="mb-3" icon-pack="feather" icon="icon-alert-circle" color="danger">
            {{$t("DeniedReason")}} {{this.project.denial_reason}}
        </vs-alert>

        <vs-alert v-if="project" :active="project.status > 2" class="mb-3" color="success"> {{$t("ProjectFinished")}}! </vs-alert>

        <div class="vx-row" v-if="project">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2" >
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view">

                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ project.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("ProjectLeader")}}</td>
                            <td>{{ project.project_leader }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("CompletedPercent")}}</td>
                            <td>{{ project.completed_percent }}%</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("OfferId")}}</td>
                            <td>{{ project.offer_id }}</td>
                        </tr>
                    </table>
                    <h6 class="mt-6">{{$t("Description")}}</h6>
                    <p style="white-space: pre-wrap" class="mt-3">{{ project.description }}</p>

                    <vs-alert :active="project.status === 1" class="mt-2" color="warning"> {{$t("ProjectWaitingForUserConfirm")}}! </vs-alert>
                    <vs-alert :active="project.status === 2" class="mt-2" color="warning"> {{$t("ProjectWaitingForClientConfirm")}}! </vs-alert>

                    <vs-button v-if="project.status === 3 || project.status === 5" class="mt-3 mr-3" style="float:left;" color="success" icon-pack="feather" icon="icon-download" type="border" @click="downloadHandoverPrintout" >{{$t("DownloadHandoverPrintout")}}</vs-button>
                    <div style="clear: both"/>

                </vx-card>
            </div>
        </div>

        <div id="ag-grid-demo">
            <vx-card :title="$t('Tasks')">

                <!-- TABLE ACTION ROW -->
                <div class="flex flex-wrap justify-between items-center">

                    <!-- ITEMS PER PAGE -->
                    <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tasks.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tasks.length }} of {{ tasks.length }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>

                            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                    <span>150</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                    </div>


                    <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                    <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                        <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                        <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
                    </div>
                </div>

                <ag-grid-vue
                        ref="agGridTable"
                        :gridOptions="gridOptions"
                        class="ag-theme-material w-100 my-4 ag-grid-table"
                        :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef"
                        :rowData="tasks"
                        rowSelection="multiple"
                        colResizeDefault="shift"
                        domLayout="autoHeight"
                        :animateRows="true"
                        :floatingFilter="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true">
                </ag-grid-vue>
                <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage" />

            </vx-card>

            <vs-popup :title="$t('Description')" :active.sync="taskDescriptionPromptOpen">
                <p>{{taskDescription}}</p>
            </vs-popup>

        </div>
    </div>
</template>
<script>

    import { AgGridVue } from "ag-grid-vue"
    import StatusRenderer from "../Task/StatusRenderer";

    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import TimeRenderer from "../Task/TimeRenderer";

    export default {
        components: {
            AgGridVue,
            StatusRenderer,
            TimeRenderer,
        },
        data() {
            return {
                project: undefined,

                taskDescription: '',
                taskDescriptionPromptOpen: false,

                selectedTaskId: 0,
                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        if (e.column.colId === 'title') {
                            this.taskDescription = e.node.data.description;
                            this.taskDescriptionPromptOpen = true;
                        }
                    },
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [
                    {
                        headerName: "ID",
                        field: 'company_task_id',
                        filter: true,
                        width: 50
                    },
                    {
                        headerName: this.$t("TaskTitle"),
                        field: 'title',
                        filter: true,
                    },
                    {
                        headerName: this.$t("BranchOffice"),
                        field: 'branch_office',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Status"),
                        field: 'status',
                        filter: true,
                        valueGetter: this.statusValueGetter,
                        cellRendererFramework: StatusRenderer,
                    },
                    {
                        headerName: this.$t("AssignedUser"),
                        field: 'company_user',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Added"),
                        field: 'added_time',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                    {
                        headerName: this.$t("Deadline"),
                        field: 'deadline',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                    {
                        headerName: this.$t("Contact"),
                        field: 'client_company_contact',
                        filter: true,
                    },
                ],
                tasks: []
            }
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(['company_task_id', 'title', 'branch_office', 'status', 'company_user', 'added_time', 'deadline', 'client_company_contact']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateProject() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.project = response.data;
                        thisIns.$nextTick(() => {
                            thisIns.resizeColumns();
                        });
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

            },
            updateTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/project/' + this.$route.params.id + "/tasks")
                    .then(function (response) {
                        thisIns.tasks = response.data
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            statusValueGetter(param) {
                switch (param.data.status) {
                    case 0:
                        return this.$t("Unassigned");
                    case 1:
                        return this.$t("Open");
                    case 2:
                        return this.$t("InProgress");
                    case 3:
                        return this.$t("Waiting");
                    case 4:
                        return this.$t("SentForConfirmation");
                    case 5:
                        return this.$t("Confirmed");
                    case 6:
                        return this.$t("Invoiced");
                    default:
                        return ""

                }
            }
        },
        computed: {
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                for(let x = 0; x < state.length; x++){
                    total += state[x].width
                }
                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
            this.updateTasks();
        },
        created() {
            this.updateProject();
        }
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
